module.exports = __webpack_public_path__ + "static/media/cult.c262ef78.jpg";